<div class="dialog-style">
  <div class="title-style">
    {{data.title}}
  </div>
  <div class="text-style">
    {{data.desc}}
  </div>
  <mat-dialog-actions align="end">
    <button class="button-style"  [matDialogClose]> Close</button>
  </mat-dialog-actions>
</div>


